import React, { FC, useRef } from 'react';
import { connect } from 'react-redux';

import ComposeFooter from '../../../components/Compose/Common/ComposeFooter';
import ComposeModalFooter from '../../../components/Compose/ComposeModal/ComposeModalFooter';

import useIsMobile from '../../../hooks/useIsMobile';
import { getLabelConfirm } from '../../../utils/forms/compose';

import useComposeUpdates from './hooks/useComposeUpdates';
import { mapDispatchToProps, mapStateToProps } from './redux';
import { Props } from './types';

/**
 * Container for message text
 *
 * @param props                Props passed to the container
 * @param props.checklist      List of checklist items
 * @param props.formId         Id of the form used to connect with submit button
 * @param props.isDraftChanged Whether the draft has been changed
 * @param props.isPending      Whether the mutation is in progress
 * @param props.labels         List of labels
 * @param props.nodeId         Whether Editor is in template edit mode
 * @param props.nodeType       Whether the compose form is being used for messages or templates
 * @param props.requestClear   Request to clear the compose form
 * @param props.status         Message status
 * @returns                    The container itself
 */
const ComposeFooterContainer: FC<Props> = ({
  checklist,
  formId,
  isDraftChanged,
  isPending,
  labels,
  nodeId,
  nodeType,
  requestClear,
  status,
}) => {
  const isEditModeRef = useRef(nodeId !== null && nodeType !== 'MESSAGE');
  const isMobile = useIsMobile();
  const updates = useComposeUpdates(checklist, labels, status);

  const commonProps = {
    formId,
    isPending,
    nodeType,
  };

  if (isMobile) {
    return (
      <ComposeFooter
        {...commonProps}
        labelConfirm={getLabelConfirm(isEditModeRef.current)}
        updates={updates}
      />
    );
  }

  return (
    <ComposeModalFooter
      {...commonProps}
      isDraftChanged={isDraftChanged}
      nodeId={nodeId}
      requestClear={requestClear}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ComposeFooterContainer);
